module.exports = __webpack_public_path__ + "static/img/hw_logo.82f3984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/hw_logo.png
// module id = qjrv
// module chunks = 1